module.exports = __webpack_public_path__ + "img/6.8bf5cb1f.png";